/**
 * Export vector path for an arrow.
 *
 * @author    Naotoshi Fujita
 * @copyright Naotoshi Fujita. All rights reserved.
 */

/**
 * Namespace definition for SVG element.
 *
 * @type {string}
 */
export const XML_NAME_SPACE = 'http://www.w3.org/2000/svg';

/**
 * The arrow vector path.
 *
 * @type {number}
 */
export const PATH = 'm15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z';

/**
 * SVG width and height.
 *
 * @type {number}
 */
export const SIZE = 40;